module.exports = __webpack_public_path__ + "images/insights-e687da90.svg";